export default {
    chatGroupContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    groupContent: {
        display: 'flex',
        maxWidth: '70%'
    },
    groupMessages: {
        margin: '0px 5px 10px 5px',
        flex: 10,
        display: 'flex',
        flexDirection: 'column'
    },
    chatWindowContainer: {
        maxWidth: 800,
        overflow: 'auto'
    },
    modalContent: {
        overflow: 'unset'
    },
    emptyContent: {
        height: '30vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    messageBubble: {
        backgroundColor: '#eee',
        borderRadius: 20,
        margin: '1px 0px',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 14,
        paddingRight: 14,
        color: '#000'
    },
    messageText: {
        fontSize: 14,
        margin: 0,
        wordBreak: 'break-word'
    }
};
